import { render, staticRenderFns } from "./IdentifyComponent.vue?vue&type=template&id=1f3535fb"
import script from "./IdentifyComponent.vue?vue&type=script&lang=js"
export * from "./IdentifyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/IdentifyComponent.vue
// module id = null
// module chunks = 